import ContentnewsCommon from './containers/contentnewsCommon'

export {default as ContentnewsCommonLayout} from './components/contentnewsCommonLayout'

export default ContentnewsCommon
